export const ModulesTabs = {
  all: 'All',
  boardroom_dynamics: 'Boaroom Dynamics',
  company_complinance: 'Company Complinance & Administration',
  company_law: 'Company Law',
  corporate_governance: 'Coporate Governance',
  developement_strategy: 'Developement Strategy',
  interpreting: 'Interpreting Financial & Accounting Information',
  risk_management: 'Risk Management',
}
export const ClassDetailTabs = {
  question: 'Questions',
  student: 'Students',
  practice_test: 'Practice Tests',
  mock_exam: 'Mock Exams',
}

export const ExamStatuses = {
  published: 'Published',
  draft: 'Draft',
  deactivated: 'Deactivated',
}

export const ClassStatus = {
  active: 'active',
  deactivate: 'deactivate',
}

export const AWS_BUCKET_NAME = import.meta.env.VITE_AWS_BUCKET_NAME
export const AWS_REGION = import.meta.env.VITE_AWS_REGION
